import { Component, OnInit, Input } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { MembersPortalService } from "../../angular-wallet-base/services/members-portal.service";

@Component({
  selector: 'app-buy-learn-more',
  templateUrl: './buy-learn-more.component.html',
  styleUrls: ['./buy-learn-more.component.scss'],
})
export class BuyLearnMoreComponent implements OnInit {
  @Input() token;
  @Input() mode;
  @Input() showPurchase = true;

  constructor(private nav: NavController,
              private membersPortal: MembersPortalService,
              private modal: ModalController) { }

  ngOnInit() {
  }

  closeModal() {
    this.modal.dismiss();
  }

  async closeAndGoToPurchase() {
    await this.membersPortal.setModalInfo(this.token);
    this.nav.navigateForward(this.token.url);
    this.closeModal();
  }

}
